module.exports = __webpack_public_path__ + "img/icon-happy-survey.75c55ffe.svg";